import Image from '@atoms/Image';
import { Description } from '@atoms/PortableText/PortableText.styled';
import type { ReactElement } from 'react';

import { GalleryWrapper } from './Gallery.styled';
import type { GalleryProps } from './Gallery.types';

export const Gallery = ({
  images,
  description,
}: GalleryProps): ReactElement => (
  <>
    <GalleryWrapper>
      {images?.map(image => {
        if (!image?.image?.asset?.url) return null;

        return (
          <Image
            key={image.image.asset.url}
            src={image.image.asset.url}
            alt={image.image.alt}
            rounded
            width={400}
            height={500}
            sizes="(max-width: 991px) 100vw, 700px"
          />
        );
      })}
    </GalleryWrapper>
    {description && <Description>{description}</Description>}
  </>
);
